if (!daz) { var daz = {}; }
daz.helper = {
	bodyScroll: {
	},
	stopBodyScroll: function() {
		daz.helper.bodyScroll.scrollTop = $(window).scrollTop()+0;
		daz.helper.bodyScroll.scrollLeft = $(window).scrollLeft()+0;
		daz.helper.bodyScroll.origTop = $('body').css('top')+'';
		daz.helper.bodyScroll.origLeft = $('body').css('left')+'';

		$('body').addClass('modal_body_noscroll');
//			.css('top', -daz.helper.bodyScroll.scrollTop)
//			.css('left', -daz.helper.bodyScroll.scrollLeft);
	},
	startBodyScroll: function() {
		$('body').removeClass('modal_body_noscroll')
			.css('top', daz.helper.bodyScroll.origTop)
			.css('left', daz.helper.bodyScroll.origLeft);

		$(window).scrollTop(daz.helper.bodyScroll.scrollTop);
		$(window).scrollLeft(daz.helper.bodyScroll.scrollLeft);

		daz.helper.bodyScroll = {};
	},
    toggleLoggedIn: function() {
		if (daz.api && daz.api.isLoggedIn()) {
            $('#account_gem').addClass('logged_in');
        } else {
            $('#account_gem').removeClass('logged_in');
        }
    },
	formatPennies: function(pennyAmount) {
		var priceStr = ""+parseInt(pennyAmount);
		return "$"+priceStr.slice(0,-2)+"."+priceStr.slice(-2);
	},
	setLocation: function(url) {
		window.location.href = url;
	},
	subNavSlide: function(parent) {
		if(parent !== null) {
			$('.'+parent + '-sub, .nav-back').show();
		}
		
		$('#top_nav_links').toggleClass('sub-nav-open');
    },
	showIconTitle: function($this) {
		var $info = $this.closest('.slab-specs').find('.icon-info');
		if (!$info.length) {
			$info = $this.parent().siblings('.icon-info');
		}
		$info.text($this.data('title')).addClass('shown');
	},
	hideIconTitle: function($this) {
		var $info = $this.closest('.slab-specs').find('.icon-info');
		if (!$info.length) {
			$info = $this.parent().siblings('.icon-info');
		}
		$info.text('').removeClass('shown');
	}
};

$(window).on('beforeDazApi', function () {
    daz.api.addCall('User/info', {callbackClass: daz.helper, callbackFunc: daz.helper.toggleLoggedIn});
});

$(window).on('ab:show', function (e, split, group) {
	$(`[data-ab="${split}"]`).each((i, elem) => {
		const $el = $(elem);
		$el.find(`[data-abgroup]`).hide();
		$el.find(`[data-abgroup="${group}"]`).show();
	})
});

$(document).ready(function() {
    daz.helper.toggleLoggedIn();
});

